/* MARMOT: home – scroll-reveal (Фаза А2, Порция 3).
   Progressive enhancement: съдържанието е ВИДИМО по подразбиране.
   Само ако има IntersectionObserver и няма prefers-reduced-motion,
   слагаме класа .marmot-reveal-armed на <html> (CSS-ът тогава скрива
   [data-marmot-reveal] до .is-revealed). Хирото и лентата нямат
   data-marmot-reveal – първият екран не се пипа (LCP/CLS). */
(function () {
  'use strict';

  // Порция 7 (т.4): стикерът на категорията носи името ѝ – при УСПЕШНО
  // зареждане скриваме дублиращото заглавие. При бавна/провалена
  // картинка заглавието остава видимо (progressive enhancement).
  function armCategoryStickers() {
    document.querySelectorAll('.marmot-cat-sticker').forEach(function (img) {
      var card = img.closest('.marmot-categories__card');
      if (!card) return;
      var hide = function () { card.classList.add('has-sticker'); };
      if (img.complete && img.naturalWidth > 0) hide();
      else img.addEventListener('load', hide, { once: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armCategoryStickers);
  } else {
    armCategoryStickers();
  }
  document.addEventListener('shopify:section:load', armCategoryStickers);

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var targets = document.querySelectorAll('[data-marmot-reveal]');
  if (!targets.length) return;

  document.documentElement.classList.add('marmot-reveal-armed');

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  targets.forEach(function (el) {
    // Вече видимите на екрана при зареждане се показват без анимация.
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.9) {
      el.classList.add('is-revealed', 'is-instant');
    } else {
      io.observe(el);
    }
  });
})();
